<style lang="scss" scoped src="./scss/data.scss"></style>

<template>
  <div class="course-data-box">
    <Title name="课程资料"></Title>
    <div class="course-data-list">
      <div
        class="course-data-item"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="course-data-l">
          <div class="box">
            <img
              class="icon-img"
              src="../../assets/images/icons/icon-download-type.png"
              alt=""
            />
            <div class="txt">{{ item.file_type }}</div>
          </div>
          <div class="course-data-info">
            <p class="name">{{ item.file_name }}</p>
            <p class="kb">
              <span class="file-size">文件大小：{{ item.file_size }}</span>
              <!-- <span>下载次数：{{item.file_size}}</span> -->
            </p>
          </div>
        </div>
        <a @click="download(item.url, item.file_name)" class="download">
          点击下载
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Title from "../../components/title";
import { getCourseData } from "../../server/courseData";
export default {
  name: "courseData",
  components: {
    Title
  },
  data() {
    return {
      params: {
        courseId: this.$route.query.courseId,
        stuId: this.$route.query.stuId
      },
      dataList: []
    };
  },
  mounted() {
    this.getCourseData(this.params);
  },
  methods: {
    async getCourseData(params) {
      const { code, msg, ...res } = await getCourseData(params);
      if (code === 0) {
        const {
          data: { list = [] }
        } = res;
        for (let i = 0; i < list.length; i++) {
          let index = list[i].file_name.lastIndexOf(".") + 1;
          list[i].file_type = list[i].file_name.substr(index);
        }
        this.dataList = list;
      } else {
        this.$message.error(msg);
      }
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        var body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
      }
    },
    download(url, filename) {
      this.getBlob(url, blob => {
        this.saveAs(blob, filename);
      });
    },
    getBlob(url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.send();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/course/data.vue